module.exports = __webpack_public_path__ + "static/chorus-5-a86bc74c90f17633336a4b13a97e9d3a.jpg";